import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../store/state/IAppState';
import { SignalRClientAction } from '../store/action/SignalRClientAction';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

@Injectable()
export class ClientActionSignalRHubService {

  constructor(private store: Store<IAppState>) { }

  public initialize(): void {
    const hubConnection = new HubConnectionBuilder()
      .configureLogging(LogLevel.Warning)
      .withUrl("/signalr/clientactionhub")
      .build();

    hubConnection.on('newClientAction', (actionModel) => {
      this.dispatchAction(actionModel);
    });

    hubConnection
      .start()
      .catch(() => { console.log('SignalR: ClientActionHub could not connect'); });
  }

  private dispatchAction(actionModel: any): void {
    this.store.dispatch(new SignalRClientAction(actionModel));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/ClientActionSignalRHubService.ts